import { render, staticRenderFns } from "./LoginAccount.vue?vue&type=template&id=74c6c530&"
import script from "./LoginAccount.vue?vue&type=script&lang=js&"
export * from "./LoginAccount.vue?vue&type=script&lang=js&"
import style0 from "./LoginAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports